
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 6.09a14 14 0 00-2.19 27.82v-9.78h-3.55v-4h3.55V17c0-3.51 2.09-5.45 5.29-5.45a21 21 0 013.13.28v3.44h-1.76a2 2 0 00-2.28 2.19v2.63h3.88l-.62 4h-3.26v9.78A14 14 0 0020 6.09z"}})])
          )
        }
      }
    